import { PageTitle } from '_metronic/layout/core'

import Select, { components } from 'react-select'
import TabsButtonGroup from 'Presentation/Components/Tabs/ButtonGroup'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import SimpleFileUploader from 'Presentation/Components/Uploader/File/SimpleUploader'
import { TABS } from '../Config'

import useViewModel from './ViewModel'
import clsx from 'clsx'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
import KumopackVariables from 'Styles/Variables/_metronic-variables.scss'

//////////
// View //
//////////

const ProfileBankInfoView: React.FC = () => {
	const {
		companyName,
		currentTab,
		setCurrentTab,
		formState,
		hasUploaded,
		isSubmitting,
		onChange,
		onSubmit,
		onDownload,
		error,
	} = useViewModel()
	const isHorizontal = !isMobileDevice()
	const bankOptions = [
		{ value: 'BBL', label: 'ธนาคารกรุงเทพ' },
		{ value: 'KBANK', label: 'ธนาคารกสิกรไทย' },
		{ value: 'KTB', label: 'ธนาคารกรุงไทย' },
		{ value: 'TMB', label: 'ธนาคารทหารไทยธนชาต' },
		{ value: 'SCB', label: 'ธนาคารไทยพาณิชย์' },
		{ value: 'BAY', label: 'ธนาคารกรุงศรีอยุธยา' },
		{ value: 'CIMB', label: 'ธนาคารซีไอเอ็มบีไทย' },
		{ value: 'TISCO', label: 'ธนาคารทิสโก้' },
		{ value: 'TCAP', label: 'ธนาคารธนชาต' },
		{ value: 'UOB', label: 'ธนาคารยูโอบี' },
		{ value: 'ICBC', label: 'ธนาคารไอซีบีซี' },
		{ value: 'LH', label: 'ธนาคารแลนด์ แอนด์ เฮ้าส์' },
		{ value: 'GSB', label: 'ธนาคารออมสิน' },
		{ value: 'GHB', label: 'ธนาคารอาคารสงเคราะห์' },
		{ value: 'CITI', label: 'ธนาคารซิตี้แบงค์' },
		{ value: 'KKP', label: 'ธนาคารเกียรตินาคินภัทร' },
		{ value: 'SMBC', label: 'ธนาคารซูมิโตโม มิตซุย' },
	]

	return (
		<ViewPageTitle companyName={companyName}>
			<div className="row gy-5">
				<div className="col-12 d-none d-xl-block">
					<TabsButtonGroup
						manualActiveTab={currentTab}
						changeTab={setCurrentTab}
						tabNames={TABS.map(tab => tab.tabName)}
						tabContents={[<></>]}
					/>
				</div>

				<div className="col-12 d-xl-none">
					<Select
						isSearchable={false}
						options={TABS.map((tab, idx) => ({ value: idx, label: tab.tabName }))}
						value={{ label: TABS.find((_, idx) => idx === currentTab)?.tabName }}
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								border: '1px solid #e1e3ea',
							}),
							menu: (baseStyles, state) => ({
								...baseStyles,
								zIndex: 9999,
							}),
						}}
						onChange={(selected: any) => {
							if (selected !== null) setCurrentTab(Number(selected?.value))
						}}
					/>
				</div>

				{/* Corporate Information */}
				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header border-0 mt-4">
							<div className="card-title">
								{/* Title */}
								<div>
									<h4 className="text-kumopack-grey-900 fw-bold mb-2">ข้อมูลทางธนาคาร</h4>
									<div className="text-kumopack-grey-600 fs-6">
										please specify page description here
									</div>
								</div>
							</div>
							<div className="mt-2 separator border-1px w-100 border-kumopack-grey-200"></div>
						</div>

						<div className="card-body">
							<FormGenerator
								formKey="bankAccountHolder"
								inputType="plain"
								label="ชื่อของเจ้าของบัญชี"
								containerClassName="mb-5"
								isHorizontal={isHorizontal}
								tooltip="ชื่อของเจ้าของบัญชี"
								value={formState.bankAccountHolder}
								onChange={e => onChange('bankAccountHolder', e.target.value)}
								isShowValid={!!error?.bankAccountHolder}
								additionalComInput={
									error?.bankAccountHolder ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.bankAccountHolder}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="bankAccountNumber"
								inputType="plain"
								label="หมายเลขบัญชีธนาคาร"
								markInput
								mark="999-9-99999-9"
								markChar={null}
								containerClassName="mb-5"
								isHorizontal={isHorizontal}
								tooltip="หมายเลขบัญชีธนาคาร"
								value={formState.bankAccountNumber}
								onChange={e => onChange('bankAccountNumber', e.target.value)}
								isShowValid={!!error?.bankAccountNumber}
								additionalComInput={
									error?.bankAccountNumber ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.bankAccountNumber}</div>
										</div>
									) : undefined
								}
							/>

							<div className={`mb-5 d-flex flex-column flex-xl-row`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>ชื่อธนาคาร</span>
									</div>
								</label>

								<div className="col-12 col-xl-9">
									<Select
										isSearchable={false}
										value={bankOptions.find(o => o.value === formState.bankAccountName) ?? null}
										options={bankOptions}
										onChange={val => onChange('bankAccountName', val?.value)}
										styles={{
											control: (baseStyles, state) => ({
												...baseStyles,
												borderColor: state.isFocused
													? KumopackVariables['kumopack-primary-700']
													: baseStyles.borderColor,
												boxShadow: 'none',
												'&:hover': {
													borderColor: KumopackVariables['kumopack-primary-700'],
												},
												'&:focus': {
													borderColor: KumopackVariables['kumopack-primary-700'],
												},
												'&:active': {
													borderColor: KumopackVariables['kumopack-primary-700'],
												},
											}),
											option: (baseStyles, state) => ({
												...baseStyles,
												backgroundColor: state.isSelected
													? KumopackVariables['kumopack-primary-700']
													: baseStyles.backgroundColor,
												'&:hover': {
													backgroundColor: KumopackVariables['kumopack-primary-700'],
													color: KumopackVariables['kumopack-base-white'],
												},
												'&:focus': {
													backgroundColor: KumopackVariables['kumopack-primary-700'],
													color: KumopackVariables['kumopack-base-white'],
												},
												'&:active': {
													borderColor: KumopackVariables['kumopack-primary-700'],
												},
											}),
										}}
										placeholder="เลือกบัญชีธนาคาร"
										className="w-100"
										components={{
											IndicatorSeparator: () => null,
											SingleValue: ({ ...props }) => (
												<components.SingleValue {...props}>
													<img
														alt="Logo"
														// @ts-ignore
														src={`/media/thailand-bank-logo/${props.data.value}.png`}
														width={25}
														className="me-2"
														style={{
															userSelect: 'none',
															pointerEvents: 'none',
															objectFit: 'cover',
														}}
													/>
													{props.data.label}
												</components.SingleValue>
											),
											Option: ({ ...props }) => (
												<components.Option {...props}>
													<img
														alt="Logo"
														// @ts-ignore
														src={`/media/thailand-bank-logo/${props.value}.png`}
														width={25}
														className="me-2"
														style={{
															userSelect: 'none',
															pointerEvents: 'none',
															objectFit: 'cover',
														}}
													/>
													{props.label}
												</components.Option>
											),
										}}
									/>
								</div>
							</div>

							{/* สำเนาสมุดบัญชีธนาคาร */}
							<div className={`mb-5 d-flex flex-column flex-xl-row`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>สำเนาสมุดบัญชีธนาคาร</span>
									</div>
								</label>

								<div className="col-12 col-xl-9">
									{/* <LogoInput wording="สำเนาสมุดบัญชีธนาคาร" description={''} /> */}
									<SimpleFileUploader
										fileKey="bankAccountPicture"
										file={formState.bankAccountPicture}
										onChange={onChange}
										download={() => onDownload('bankAccountPicture')}
										hasUpdate={hasUploaded}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-12 text-end">
					<button
						className={clsx(
							'btn btn-sm white-button text-kumopack-grey-700 fw-bold me-4 mb-5 mb-xl-0',
							{
								'w-200px': !isMobileDevice(),
								'w-sm-100': isMobileDevice(),
							}
						)}>
						ยกเลิก
					</button>

					<button
						disabled={isSubmitting}
						onClick={onSubmit}
						className={clsx(
							'btn btn-sm btn-kumopack-secondary-600 text-kumopack-base-white fw-bold',
							{
								'w-200px': !isMobileDevice(),
								'w-sm-100': isMobileDevice(),
							}
						)}>
						บันทึก
					</button>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode; companyName: string }> = ({
	children,
	companyName,
}) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'My Account',
						path: '/profile',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Bank Information',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				{companyName}
			</PageTitle>

			{children}
		</>
	)
}

export default ProfileBankInfoView
